import { Directive, ElementRef, HostListener, Input, Renderer } from '@angular/core';
@Directive({ selector: '[autoNext]' })
export class AutoNextDirective {


    constructor(private el: ElementRef, renderer: Renderer) {}

      @Input('autoNext') nextElID: string;

      //listen for keyup event and then check if text length  = maxlength. if so then change focus to provided HTML element
      @HostListener('keyup') onchange() {
        if(this.el.nativeElement.value.length == this.el.nativeElement.maxLength) {
            let nextElement:HTMLElement = document.getElementById(this.nextElID);
            if(nextElement) {
                nextElement.focus();
            }
        }
  }
}


// WEBPACK FOOTER //
// ./app/shared/directives/autoNext.directive.ts